import type SvgProps from '~/components/icons/svg-props'

// TODO: generalize this to SvgProps, so we can also support outline variant

type InfoIconProps = SvgProps & {
  outline?: boolean
}

export default function InfoIcon({ outline = false, ...rest }: InfoIconProps) {
  return outline ? <InfoOutlined {...rest} /> : <InfoFilled {...rest} />
}

function InfoOutlined(props: SvgProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12 17.3488C12.3853 17.3488 12.6977 17.0365 12.6977 16.6512V11.0698C12.6977 10.6845 12.3853 10.3721 12 10.3721C11.6147 10.3721 11.3023 10.6845 11.3023 11.0698V16.6512C11.3023 17.0365 11.6147 17.3488 12 17.3488Z"
        fill="currentColor"
      />
      <path
        d="M12 7.34884C12.5138 7.34884 12.9302 7.76532 12.9302 8.27907C12.9302 8.79282 12.5138 9.2093 12 9.2093C11.4862 9.2093 11.0698 8.79282 11.0698 8.27907C11.0698 7.76532 11.4862 7.34884 12 7.34884Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 3.39535C7.24778 3.39535 3.39535 7.24778 3.39535 12C3.39535 16.7522 7.24778 20.6047 12 20.6047C16.7522 20.6047 20.6047 16.7522 20.6047 12C20.6047 7.24778 16.7522 3.39535 12 3.39535Z"
        fill="currentColor"
      />
    </svg>
  )
}

function InfoFilled(props: SvgProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.998 17.997" {...props}>
      <path
        id="Subtraction_53"
        data-name="Subtraction 53"
        d="M9,18a9,9,0,1,1,9-9A9.009,9.009,0,0,1,9,18ZM7.78,6.86v7.047H9.939V6.86ZM8.866,3.79a1.316,1.316,0,0,0-.929.335,1.106,1.106,0,0,0-.36.841,1.091,1.091,0,0,0,.36.827,1.316,1.316,0,0,0,.929.335,1.3,1.3,0,0,0,.915-.335,1.088,1.088,0,0,0,.36-.827,1.1,1.1,0,0,0-.36-.841A1.3,1.3,0,0,0,8.866,3.79Z"
        transform="translate(0.002 -0.002)"
        fill="currentColor"
      />
    </svg>
  )
}
